export const MEETING_ROOM_PERMISSION_RESOURCE = {
  dashboard: 'meeting-room-dashboard',
  rooms: 'meeting-room-rooms',
  bookings: 'meeting-room-bookings',
  minutes: 'meeting-room-minutes',
  reports: 'meeting-room-reports',
  config: 'meeting-room-config',
} as const;

export const MEETING_ROOM_PERMISSION_ACTION = {
  create: 'create',
  update: 'update',
  delete: 'delete',
  approve: 'approve',
  cancel: 'cancel',
  checkIn: 'check-in',
  complete: 'complete',
  dispatch: 'dispatch',
  export: 'export',
  manage: 'manage',
} as const;
